import { render, staticRenderFns } from "./NewChartJs.vue?vue&type=template&id=6e71101e"
import script from "./NewChartJs.vue?vue&type=script&lang=js"
export * from "./NewChartJs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports